export class NoSuchServiceError extends Error {
  constructor(serviceIdentifier: string, isShared: boolean) {
    super(`There is no ${isShared ? '' : 'Non'}Shared service: "${serviceIdentifier}".`);
  }
}
